import { useEffect } from 'react'

const EXTENSION_ERROR_PATTERNS = [
  'chrome-extension://',
  'moz-extension://',
  'inpage.js',
  'MetaMask',
]

function isExtensionNoise(value: unknown): boolean {
  const text =
    value instanceof Error
      ? `${value.message} ${value.stack ?? ''}`
      : typeof value === 'string'
        ? value
        : ''

  return EXTENSION_ERROR_PATTERNS.some((pattern) => text.includes(pattern))
}

/**
 * Browser wallet extensions (MetaMask and friends) inject their own script into
 * every page and reject promises when their background worker is unavailable.
 * Those rejections have nothing to do with this site, so we stop them from
 * bubbling up as page-level errors.
 */
export function useIgnoreExtensionErrors() {
  useEffect(() => {
    const onRejection = (event: PromiseRejectionEvent) => {
      if (isExtensionNoise(event.reason)) {
        event.preventDefault()
      }
    }

    const onError = (event: ErrorEvent) => {
      if (isExtensionNoise(event.error) || isExtensionNoise(event.filename)) {
        event.preventDefault()
      }
    }

    window.addEventListener('unhandledrejection', onRejection)
    window.addEventListener('error', onError)

    return () => {
      window.removeEventListener('unhandledrejection', onRejection)
      window.removeEventListener('error', onError)
    }
  }, [])
}
